import React, { useEffect, useState } from 'react';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  Modal,
  Spinner,
} from '@heroui/react'; // or wherever your Hero UI Modal is exported
import { useGetPdfFileMutation } from 'src/services/orders/orders';

interface PdfViewerProps {
  filePath: string;
  fileLabel?: string;
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ filePath, fileLabel, label, size, className }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  // The mutation that returns a PDF blob
  const [getPdfFile, { data: pdfBlob, isLoading, isError, error }] =
    useGetPdfFileMutation();

  // Once we receive the PDF blob, create an object URL and open the modal
  useEffect(() => {
    if (pdfBlob) {
      const objectUrl = URL.createObjectURL(pdfBlob);
      setPdfUrl(objectUrl);
      setIsModalOpen(true);
    }
  }, [pdfBlob]);

  // Clean up the object URL when the component unmounts or pdfUrl changes
  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);

  const handleViewPdf = () => {
    const fileName = filePath.split('/').pop();
    if (fileName) {
      // Trigger the API call to fetch the PDF blob
      getPdfFile({ fileName });
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setPdfUrl(null); // optional: clear the PDF URL
  };

  return (
    <>
      <Button onClick={handleViewPdf} disabled={isLoading} size={size} variant="solid" className={`flex items-center justify-center shadow-sm font-medium transition-colors duration-200 ${className}`} style={{ backgroundColor: "var(--color-primary)", color: "var(--text-invert)" }}>
      {isLoading ? <Spinner size="sm" variant="simple" color="danger"/> : label ?? 'View'}
      </Button>
      {isError && (
        <p className="text-red-500">
          Error loading PDF: {JSON.stringify(error)}
        </p>
      )}

      <Drawer
        isKeyboardDismissDisabled={true}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        size="5xl"
        placement='top'
        backdrop="blur"
        // disableAnimation
        // onOpenChange={onOpenChange}
        
        classNames={{
          closeButton:
            'bg-white/[0.06] m-2 hover:bg-white/[0.09] active:bg-white/[0.06] text-white p-2',
          header: 'px-6',
        }}
        className="bg-primary"
      >
        <DrawerContent>
          {(onClose) => (
            <>
              <DrawerHeader className="flex flex-col gap-1 text-white text-2xl">
                 {fileLabel ?? 'PDF Preview'}
              </DrawerHeader>
              <DrawerBody>
                <div className="p-4 m-auto" style={{ height: '90vh', width: '55vw' }}>
                  {pdfUrl && (
                    <iframe
                      src={`${pdfUrl}#toolbar=1&navpanes=0&scrollbar=1`}
                      title="PDF Preview"
                      className="w-full h-full"
                    />
                  )}
                </div>
              </DrawerBody>
             
            </>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default PdfViewer;
